import ApiClient from 'api-client/ApiClient'
import createContextLoader from 'core/helpers/createContextLoader'
import createCRUDActions from 'core/helpers/createCRUDActions'
import { ActionDataKeys } from 'k8s/DataKeys'
import Bugsnag from 'utils/bugsnag'
import { emptyObj, isNilOrEmpty } from 'utils/fp'

const serviceMappings = {
  aodh: 'internal',
  azmanager: 'admin',
  ceilometer: 'internal',
  cinder: 'internal',
  credsmgr: 'admin',
  glance: 'admin',
  gnocchi: 'internal',
  ironic: 'public',
  mors: 'internal',
  murano: 'internal',
  neutron: 'internal',
  nova: 'internal',
  panko: 'internal',
  kubernetes: 'internal',
  resmgr: 'internal',
  tasker: 'admin',
}

const { keystone } = ApiClient.getInstance()

// const whichInterface = (serviceName) => serviceMappings[serviceName] || 'internal'
const whichInterface = (serviceName) => (serviceName === 'glance-cluster' ? 'admin' : 'public')

export const loadServiceCatalog = createContextLoader(ActionDataKeys.ServiceCatalog, async () => {
  const services = await keystone.getServicesForActiveRegion(true)

  // For glance service, we need both admin and public endpoints
  // Extract glance admin and public endpoints separately
  if (
    !isNilOrEmpty(services['glance']) &&
    !isNilOrEmpty(services['glance']['admin']) &&
    !isNilOrEmpty(services['glance']['public'])
  ) {
    services['glance-admin'] = {
      admin: {
        ...(services.glance['admin'] || {}),
        name: 'glance-admin',
        type: `${(services.glance['admin'] || {}).type || 'image'} (admin)`,
      },
    }
    services['glance-public'] = {
      public: {
        ...(services.glance['public'] || {}),
        name: 'glance-public',
        type: `${(services.glance['public'] || {}).type || 'image'} (public)`,
      },
    }
    delete services.glance
  }

  return Object.entries(services || emptyObj).map(([name, service]) => {
    const iface = whichInterface(service)
    const endpoint = (service && service[iface]) || service[Object.keys(service)[0]]
    return {
      id: endpoint.id,
      name,
      type: endpoint.type,
      // glance-cluster can have multiple endpoints, show all of them
      url: name === 'glance-cluster' ? endpoint.allEndpoints : endpoint.url,
      iface: endpoint.iface,
    }
  })
})

const endpointsActions = createCRUDActions(ActionDataKeys.ApiEndpoints, {
  // TODO: implement list fetching real data
  listFn: async () => {
    Bugsnag.leaveBreadcrumb('Attempting to get API endpoints')
    const whitelist = ['kubernetes', 'keystone']
    const services = await loadServiceCatalog()
    return services.filter((service) => whitelist.includes(service.name))
  },
})

export default endpointsActions
